<app-header (idiomaAlterado)="alterarIdioma($event)"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
